
import api from "../request";

function getAttendanceList(reqData) {
  return api
    .post("attendance/list", { reqData })
    .then(({ data }) => {
      return data;
    });
}

function getAttendanceById(reqData) {
  return api
    .post("attendance/get-by-id", { reqData })
    .then(({ data }) => {
      return data;
    });
}

function getStudents(reqData) {
  return api
    .post("attendance/get-students", { reqData })
    .then(({ data }) => {
      return data;
    });
}

function submitAttendance(reqData) {
  return api
    .post("attendance/submit", { reqData })
    .then(({ data }) => {
      return data;
    });
}

function getBatchSubjects(reqData) {
  return api
    .post("data-tree/batch-subjects", { reqData })
    .then(({ data }) => {
      return data;
    });
}

export default {
  getAttendanceList,
  getAttendanceById,
  getStudents,
  submitAttendance,
  getBatchSubjects,
};
